import { cn } from "@/lib/utils"
import { CHAT_MESSAGE_SEPARATOR } from "@/modules/chats/types/chat-message"

export const renderMessageLines = (messageContent: string, className?: string) => {
  return messageContent.split(CHAT_MESSAGE_SEPARATOR.BREAK_LINE).map((messageLine, index) => {
    const messageLineKey = `${messageLine}_${index}`
    return (
      <div key={messageLineKey} className={cn("text-sm wrap-anywhere", className)}>
        {messageLine}
      </div>
    )
  })
}
